<template>
	<div>
		<template v-if="categorias && !loading">
			<template v-for="(categoria, i) in categorias">
				<CardExtras :key="i" v-if="filtroCategorias(categoria, i)">
					<template v-slot:cabecalho>
						<div>
							<h1 class="categoria__nome">{{ categoria.nome }}</h1>
							<div class="categoria__detalhes">{{ detalhesCategoria(categoria) }}</div>
						</div>
						<div class="categorias__etapas">
							{{ (!verificarMobile() ? categoriaSelecionada + 1 : i + 1) + '/' + categorias.length }}
							<div class="categoria__botoes-nav" v-if="!verificarMobile()">
								<Botao
									pequeno
									@clicar="voltarCategoria()"
									transparente
									:disabled="categoriaSelecionada == 0"
								>
									<template v-slot:antes>
										<v-icon> mdi-arrow-left </v-icon>
									</template>
								</Botao>
								<Botao
									pequeno
									@clicar="avancarCategoria(categoria)"
									transparente
									:disabled="categoriaSelecionada + 1 == categorias.length"
								>
									<template v-slot:antes>
										<v-icon> mdi-arrow-right </v-icon>
									</template>
								</Botao>
							</div>
						</div>
					</template>
					<template v-slot:conteudo>
						<template v-for="(extra, j) in categoria.extrascategorizados">
							<li :key="j" v-if="!categoria.editavel">
								<div>
									<div>
										{{ extra.descricao }}
										<span v-if="!categoria.editavel && extra.cobrar">{{
											retornarQuantidadeFixa(extra)
										}}</span>
									</div>
									<div
										style="font-weight: bold; font-size: 13px"
										v-if="extra.cobrar || categoria.saboresPizza"
									>
										{{
											convertDinheiro(
												extra.preco * (extra.quantidadeFixa > 0 ? extra.quantidadeFixa : 1)
											).toString()
										}}
									</div>
								</div>
								<v-spacer />

								<v-checkbox
									class="categoria__checkbox"
									:value="extra"
									v-model="acompanhamentos"
									:disabled="categoria.fixo > 0 || extra.tipo == 3"
									hide-details
								/>
							</li>
							<li :key="extra.id" v-else>
								<div>
									<div>
										{{ extra.descricao }}
									</div>
									<div style="font-weight: bold; font-size: 13px" v-if="extra.cobrar || extra.tipo == 2 || extra.tipo ==4">
										{{ convertDinheiro(extra.preco.toString()) }}
									</div>
								</div>
								<v-spacer />
								<v-checkbox
									class="categoria__checkbox"
									v-if="extra.cobrar == false"
									:value="extra"
									v-model="acompanhamentos"
									:disabled="categoria.fixo > 0 ? true : false"
									hide-details
								/>

								<div class="categoria__botoes" v-if="extra.cobrar || extra.tipo==4 || extra.tipo==2">
									<button
										:disabled="categoria.fixo > 0 || extra.tipo==4"
										@click="diminuiAdicional(extra)"
										v-if="extra.quantidade>0"
									>
										<v-icon > mdi-minus </v-icon>
									</button>
									<div v-if="getQuantidadeAdicional(extra.id)">
										{{getQuantidadeAdicional(extra.id)}}
									</div>
									<button
										@click="adicionaAdicional(extra)"
										:disabled="categoria.fixo > 0 || extra.tipo==4"
									>
										<v-icon > mdi-plus </v-icon>
									</button>
								</div>
							</li>
						</template>
					</template>
				</CardExtras>
			</template>
		</template>
	</div>
</template>

<script>
import Botao from '../shared/Botao.vue'
import CardExtras from './CardExtras.vue'

export default {
	props: {
		categorias: Array,
		acompanhamentosSelected: Array,
		adicionaisSelected: Array,
		contadorCategoria: Number,
	},
	components: { Botao, CardExtras },
	data: function () {
		return {
			quantidade: 1,
			precos: [],
			observacao: '',
			adicionais: [],
			produto: {},
			acompanhamentos: [],
			renderizar: false,
			valorInicial: 0,
			loading: false,
			categoriaSelecionada: 0,
		}
	},
	methods: {
		voltarCategoria() {
			if (this.categoriaSelecionada > 0) this.categoriaSelecionada--
		},
		avancarCategoria(categoria) {
			if (this.categoriaSelecionada < this.categorias.length - 1) {
				if (this.verificarQuantidade(categoria)) this.categoriaSelecionada++
			}
		},
		selecionarAdicionais() {
			this.$emit('selecionarAdicionais', this.adicionais)
		},
		selecionarAcompanhamentos() {
			this.$emit('selecionarAcompanhamentos', this.acompanhamentos)
		},
		filtroCategorias(categoria, i) {
			if (this.verificarMobile()) return categoria.extrascategorizados.length > 0 ? true : false
			else return categoria.extrascategorizados.length > 0 && i == this.categoriaSelecionada ? true : false
		},
		detalhesCategoria(categoria) {
			if (categoria.minimo == 0 && categoria.maximo == 0) return ''
			else return `Mínimo: ${categoria.minimo} / Máximo: ${categoria.maximo}`
		},
		verificarQuantidade(categoria) {
			let quantidade = 0

			if (categoria.minimo == 0 && categoria.maximo == 0) return true
			else {
				this.adicionais.map((item) => {
					if (item.categoriumId == categoria.id) quantidade = quantidade + item.quantidade
				})
				this.acompanhamentos.map((item) => {
					if (item.categoriumId == categoria.id) quantidade++
				})

				if (quantidade >= categoria.minimo && quantidade <= categoria.maximo) return true
				else if (quantidade < categoria.minimo)
					if (categoria.minimo == 1)
						this.$store.dispatch(
							'showError',
							`É obrigatório selecionar no mínimo ${categoria.minimo} item!`
						)
					else
						this.$store.dispatch(
							'showError',
							`É obrigatório selecionar no mínimo ${categoria.minimo} itens!`
						)
				else if (quantidade > categoria.maximo)
					if (categoria.maximo == 1)
						this.$store.dispatch('showError', `É permitido selecionar no máximo ${categoria.maximo} item!`)
					else
						this.$store.dispatch('showError', `É permitido selecionar no máximo ${categoria.maximo} itens!`)
			}
		},
		verificarValorSabor() {
			if (this.valorSabor > 0) return true
			else this.$store.dispatch('showError', 'Não há valor lançado!')
		},
		adicionaAdicional(adicional) {
			if (!adicional.quantidade) {
				adicional.quantidade = 1
				this.adicionais.push(adicional)
			} else {
				this.adicionais.map((item, i) => {
					if (item.id == adicional.id) {
						this.adicionais.splice(i, 1)
						adicional.quantidade++
						this.adicionais.push(adicional)
					}
				})
			}
		},
		diminuiAdicional(adicional) {
			if (adicional.quantidade > 0) {
				adicional.quantidade--

				this.adicionais.map((item, i) => {
					if (item.id == adicional.id) {
						this.adicionais.splice(i, 1)
						this.adicionais.push(adicional)
					}
					if (adicional.quantidade == 0) this.adicionais.splice(i, 1)
				})
			}
		},
		getQuantidadeAdicional(id) {
			var item = this.adicionais.filter((p) => p.id == id && p.quantidade > 0)

			if (item.length > 0) return item[0].quantidade
			else return 0
		},
		retornarQuantidadeFixa(extra) {
			var quantidade = extra.quantidadeFixa > 0 ? extra.quantidadeFixa.replace('.', ',') : '1,00'
			return `| QTD: ${quantidade}`
		},
		selecionarCategoria() {
			this.$emit('selecionarCategoria', this.categoriaSelecionada)
		},
	},
	beforeMount() {
		this.adicionais = this.adicionaisSelected
		this.acompanhamentos = this.acompanhamentosSelected
	},
	watch: {
		adicionais() {
			this.selecionarAdicionais()
		},
		acompanhamentos() {
			this.selecionarAcompanhamentos()
		},
		categoriaSelecionada() {
			this.selecionarCategoria()
		},
	},
}
</script>

<style scoped>
ul,
li {
	list-style-type: none;
	margin: 0;
	padding: 0;
}

li {
	display: flex;
}

.theme--light.v-icon {
    color: #6d6767;
}

.categoria__cabecalho {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1rem;
}

.categoria__nome {
	font-size: 1rem;
	color: #6d6767;
}

.categoria__detalhes {
	color: #6d6767;
}

.categoria__botoes-nav {
	display: flex;
	gap: 1rem;
	color: #6d6767;
}

.categoria__checkbox {
	margin: 0;
}

.categoria__itens {
	max-height: 15rem;
	overflow: auto;
	padding: 0.5rem;
	margin-top: -1rem;
	margin-bottom: -1rem;
}

.categorias__etapas {
	color: #6d6767;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.categoria__botoes {
	display: flex;
	align-items: center;
	gap: 1rem;
}

::-webkit-scrollbar {
	height: 0.5em;
	width: 0.5em;
}

::-webkit-scrollbar-track {
	background: #d9d9d9;
	border-radius: 100vw;
	margin-block: 1rem;
}

::-webkit-scrollbar-thumb {
	background: #6d6767;
	border-radius: 100vw;
}

::-webkit-scrollbar-thumb:hover {
	background: var(--v-primary-base);
}

@media (max-width: 600px) {
	.categoria__itens {
		max-height: 100%;
		overflow: hidden;
		padding: 0rem;
		margin-top: 0rem;
		margin-bottom: 0rem;
	}
}
</style>